import { render } from "./AboutCallAction.vue?vue&type=template&id=1cd9f85c&scoped=true"
import script from "./AboutCallAction.vue?vue&type=script&lang=js"
export * from "./AboutCallAction.vue?vue&type=script&lang=js"

import "./AboutCallAction.vue?vue&type=style&index=0&id=1cd9f85c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd9f85c"]])

export default __exports__